import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import PrimeVue from 'primevue/config'

// import 'primevue/resources/themes/saga-blue/theme.css' // theme
// import 'primevue/resources/primevue.min.css' // core css
import 'primeicons/primeicons.css' // icons

sessionStorage.removeItem('reloaded');

const app = createApp(App)

app.use(PrimeVue) // use PrimeVue
app.use(store)  // use Vuex Store
app.use(router) // use Vue Router
app.mount('#app')
